
import React from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import "./styles.css";

const SelectTable = ({showTable, setShowTable} ) =>{

    const getClassNameButton = (idTable) => 
        (showTable === idTable ? "success" : "secondary") + " switch-button";
    
    return (
        <ButtonGroup>
            <Button 
                color={getClassNameButton(1)} 
                onClick={() => setShowTable(1)} 
                active={showTable === 1}
            >
                Tabla Movimientos
            </Button>
            <Button 
                color={getClassNameButton(2)}  
                onClick={() => setShowTable(2)}
                active={showTable === 2}
            >
                Tabla Deudas
            </Button>
        </ButtonGroup>
    )
}

export default SelectTable;


// WEBPACK FOOTER //
// ./src/views/Inversionistas/Resumen/SelectTable.js